import { ru, enUS, uk, ro } from 'date-fns/locale';
import {isMd} from "../api/api";

const supportLangs = ['uk', 'ro' , 'ru']

export const getLang = (lang) => {
  let labels = {
    timeCaption: '',
    lang: enUS,
  };
  switch (lang) {
    case 'uk':
      return (labels = {
        timeCaption: 'Час',
        lang: uk,
      });
    case 'ro':
      return (labels = {
        timeCaption: 'Timp',
        lang: ro,
      });
    case 'ru':
      return (labels = {
        timeCaption: 'Время',
        lang: ru,
      });
      default:
          if (isMd) {
              return (labels = {
                  timeCaption: 'Timp',
                  lang: ro,
              });
          } else {
              return (labels = {
                  timeCaption: 'Час',
                  lang: uk,
              });
          }
  }
};

export const getLangCode = (lang) => {
    if(supportLangs.includes(lang)) {
        return lang
    }
    else{
        if (isMd){
            return 'ro'
        }
        else{
            return 'uk'
        }
    }
}
